import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { Dispatch, bindActionCreators } from 'redux';
import { fetchAboutContent } from 'Components/InfoAbout/Redux/thunks';
import { getAboutContent } from 'Components/InfoAbout/Redux/selectors';
import InfoAbout from 'Components/InfoAbout/InfoAbout';

interface IPropsInternal {
  content: Julius.Website.AboutPageViewModel;
  fetchAboutContent: () => void;
}

type Props = IPropsInternal;

class InfoAboutContainer extends React.PureComponent<Props> {

  componentDidMount() {
    this.props.fetchAboutContent();
  }

  render() {
    return <InfoAbout content={ this.props.content } />;
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    content: getAboutContent(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    fetchAboutContent,
  }, dispatch);
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(InfoAboutContainer);


// WEBPACK FOOTER //
// ./src/components/InfoAbout/InfoAboutContainer.tsx